import React from "react";
import {
  useMsal,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import bgImage from "../../assets/img/loginPage.gif";
import logo from "../../assets/img/Aays.png";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "./Home";
import "../auth/SigninWidget.scss";
import { loginRequest } from "../auth/authConfig"; // make sure this points to your loginRequest

const loginStageStyle = {
  backgroundImage: `url(${bgImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
};


const Login = () => {
  const { instance } = useMsal(); // Access MSAL instance from context
  const login = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest); // Trigger login popup
      console.log("Login successful", loginResponse);
      const userEmail = loginResponse && loginResponse?.idTokenClaims?.preferred_username;
      const userName = loginResponse && loginResponse?.idTokenClaims?.name;
      localStorage.setItem("myemail", userEmail.toLowerCase());
      localStorage.setItem("userName", userName);
    } catch (error) {
      console.error("Login failed", error);
    }
  };

  return (
    <div>
      <AuthenticatedTemplate>
        <Home />
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
       <div className="Buttons">
          <div className="loginPage">
            <div className="login_body_content">
              <div className="login_shell">
                <section
                  className="login_stage"
                  style={loginStageStyle}
                >
                  <div className="pointer-events-none absolute top-0 left-0 right-0 z-10 h-screen bg-gradient-to-r from-brandPurple/20 to-brandPurple/10"></div>
                  <div className="pointer-events-none absolute bottom-0 left-0 right-0 z-10 h-6 bg-gradient-to-r from-brandPurple to-brandPurple"></div>
                  <div className="relative z-20 grid w-full place-items-center">
                    <div className="login_card login_card_centered">
                      <img src={logo} alt="Aadi" className="login_card_logo" />
                      <div className="text-center">
                        <p className="login_card_label">{process.env.REACT_APP_NAME}</p>
                        <h1 className="login_card_title">Welcome back!</h1>
                        <p className="text-[14px] text-[#ffffff] text-center mt-4">
                          Sign in to access the Platform and continue.
                        </p>
                      </div>
                     

                      <button className="btn_login" onClick={login}>
                        <span className="microsoft_mark" aria-hidden="true">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </span>
                        Sign In with Microsoft Account
                      </button>

                    
                       <p className="login_support_text text-center mt-4">
                        Access to this system is limited. Contact
                        <a
                          rel="noreferrer"
                          target={"_blank"}
                          href="mailto:anshuman.bhar@aaysanalytics.com"
                        >
                          anshuman.bhar@aaysanalytics.com
                        </a>
                        for account enablement and onboarding support.
                      </p>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
};

export default Login;
